import React from 'react';
/**
 * Gen 3 category page H1 heading.
 */
export function Heading() {
  return <h1 className="text-4xl sm:text-5xl font-black text-gray-900 uppercase tracking-tight mb-6" data-id="element-584">
      Gen 3
    </h1>;
}